<!--
 * @Author: kongxiangyu
 * @Date: 2022-11-22 11:29:37
 * @LastEditTime: 2023-02-10 12:37:09
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
-->
<template>
    <div class="redPacket">
        <div class="text">恭喜获得</div>
        <div class="packet">
            <div class="price-box">
                <span class="unit">¥</span>
                <span class="price">{{ (dialogData && dialogData.card_data.coupon_list[0].discount_amount)
                    || '5' }}</span>
            </div>
            <div class="right">
                <p class="title">{{ (dialogData && dialogData.card_data.coupon_list[0].use_rule_str)
                    || '情人节满减优惠' }}</p>
                <p class="subTitle">{{ (dialogData && dialogData.card_data.coupon_list[0].use_time_str)
                    || '百度地图1分钱团美食' }}</p>
            </div>

        </div>
        <div class="btn" @click="handleGet"></div>
    </div>
</template>

<script>
import Server from '../../../../service.js';
import EventBus from '../../../../constant/EventBus.js';
import StatisticConst from '../../../../constant/StatisticConst.js';
import {getParamsFromUrl, getPlatInfo, openBdMap, goToLogin} from '@baidu/map-fe-utils';
import {backToNativeWithTransparent} from '../../../../constant/JumpFunc.js';
export default {
    props: {
        dialogData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {

        };
    },
    mounted() {

    },
    methods: {
        /**
         * 确认收下，非端内跳转地图
         */
        handleGet() {
            if (!getPlatInfo().isNative) {
                backToNativeWithTransparent();
                return;
            }
            StatisticConst.getRedPacket();
            const params = {
                app_id: '20230206',
                activity_id: getParamsFromUrl().activity_id,
                cuid: getParamsFromUrl().cuid,
                city_id: getParamsFromUrl().c || 0,
                bdmap_coupon_ids: this.dialogData.card_data.coupon_list[0].bdmap_coupon_id,
                room_id: this.dialogData.room_id
            };
            // eslint-disable-next-line @babel/new-cap
            Server('PacketRevive', params)
                .then(res => {
                    try {
                        if (res && res.errno === 4003) {
                            EventBus.$emit('jointLogin');
                        }
                        else if (res && res.errno === 4000) {
                            if (getPlatInfo().isIos) {
                                EventBus.$emit('jointLogin');
                            }
                            else if (getPlatInfo().isAndroid) {
                                goToLogin();
                            }
                        }
                        else if (res && (res.errno === 4005 || res.errno === 4006 || res.errno === 4007)) {
                            this.$toast(res.msg);
                            this.$emit('listenToChildEvent');
                        }
                        else if (res && res.errno === 0) {
                            this.$toast('领取成功');
                            this.$emit('listenToChildEvent');
                            EventBus.$emit('refresh');
                        }
                        else {
                            this.$toast(res.msg);
                        }
                    }
                    catch (e) {
                        console.error('error', e);
                    }
                })
                .catch(e => {
                    this.$toast('系统异常，请稍后重试～');
                    console.error('error', e);
                });

        }
    }
};
</script>

<style lang="scss" scoped>
    .redPacket{
        background-image: url('../../../../assets/packet.png');
        background-size: 100% 100%;
        width:290px;
        height:322px;
        position:relative;
        .text{
            font-size: 18px;
            font-weight: 600;
            color:#F8EAD9;
            text-align:center;
            margin-top:70px;
        }
        .btn{
            width:162px;
            height:54px;
            margin:56px auto 0;
            background-image: url('../../../../assets/packet-get.png');
            background-size: 100% 100%;
        }
        .packet{
            background-image: url('../../../../assets/packet-bg.png');
            background-size: 100% 100%;
            width:200px;
            height:66px;
            margin:15px auto 0;
            display:flex;
            .price-box{
                width:53px;
                height:66px;
                line-height:66px;
                text-align:center;
                color:#CF0F22;
                .unit{
                    font-size: 19px;
                }
                .price{
                    font-size:30px;
                    font-weight: bold;
                }
            }
            .right{
                padding-left: 10px;
                height:66px;
                display:flex;
                flex-direction:column;
                justify-content: center;
            }
            .title{
                font-size:15px;
                color:#E21D31;
                font-weight: bold;
                line-height:16px;
                text-align: left;
            }
            .subTitle{
                font-size: 10px;
                color: #989693;
                line-height:12px;
                margin-top:8px;
                text-align: left;
            }

        }
    }
</style>